import { gql } from '@apollo/client';

export default gql`
  query productionOrders($patientId: ID) {
    productionOrders(patientId: $patientId) {
      id
      createdAt
      hexCode
      partnerState
      productionOrderItemsAttributes {
        id
        deliveredAt
        product {
          id
          name
          warrantyAllowed
        }
      }
      sendToClinic
      updatedAt
      warranties {
        id
        state
        hexCode
        createdAt
        updatedAt
      }
      warrantyId
      disableWarranty
    }
  }
`;
